export default __webpack_public_path__ + "static/media/30.31fca381.jpg";